import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@volkswagen-onehub/components-core';
import { VehicleContext } from '../../utils/vehicle-context';
import BuildYourDeal from '../BuildYourDeal';
import { CustomDetailsCTA } from '../../styles/components';
import { getLang, getTranslations } from '../../translations';
import { useFeatureServices } from '../../use-feature-services';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../../utils/get-tracking-event-data';
import { DealerData, VehicleData } from '../../types';
import { useDealersStore } from '../../utils/use-dealers-store';

const ActionsContainer = styled.div`
  display: flex;
  column-gap: ${props => props.theme.size.dynamic0020};

  a {
    text-decoration: none;

    button {
      width: 100%;
    }
  }
`;

export const Actions = () => {
  const { tracking } = useFeatureServices();
  const vehicle = useContext(VehicleContext) as VehicleData;
  const { vin, dealer_id, stock_number } = vehicle;
  const { labels } = getTranslations();

  const lang = getLang();
  const { isLoading, allDealers: all_dealers } = useDealersStore();
  const dealer = (all_dealers as DealerData[])?.filter(x => x.static_dealer_id === dealer_id)[0];

  const idno = vin ? vin : stock_number;

  return (
    isLoading
    ? <></>
    : <ActionsContainer>
      <Link
        to={`/details/${idno}`}
        onClick={(e) => {
          tracking.track('VWBasic_VehicleButton_Click', {
            ...createConstantData('VWBasic_VehicleButton_Click', vehicle.category),
            configuration: createConfiguration('VWBasic_VehicleButton_Click', vehicle, lang),
            partner: createPartner(dealer),
            process: createProcess("2A"),
            link: {
              url: e.currentTarget.href,
              name: e.currentTarget.innerText.trim()
            }
          });
        }}
      >
        <CustomDetailsCTA
            tabIndex={-1}
            stretchContent
            ariaLabel={labels.view_details}
            emphasis='secondary'
            tag='button'
        >
          { labels.view_details }
        </CustomDetailsCTA>
      </Link>

      <BuildYourDeal vehicle={vehicle} />

    </ActionsContainer>
  );
};
